import { Button, Modal } from '@orbind/ui'

/**
 * Excluir um item que TEM filhos (SPEC-20261006-1304): só ele, ou a árvore
 * inteira?
 *
 * As duas respostas são legítimas — às vezes o pai foi criado por engano e os
 * filhos valem; às vezes a frente inteira caiu. Decidir por quem clicou seria
 * errar metade das vezes, e das duas maneiras o estrago é grande.
 *
 * A janela diz QUANTOS itens vão junto antes de a pessoa escolher: é o número
 * que muda a decisão, e ele não está à vista na tela.
 */
export function ExcluirComFilhosModal({
  codigo,
  titulo,
  filhos,
  excluindo,
  onSomenteEste,
  onComFilhos,
  onFechar,
}: {
  codigo: string
  titulo: string
  /** Quantos itens existem ABAIXO deste, em toda a árvore. */
  filhos: number
  excluindo: boolean
  onSomenteEste: () => void
  onComFilhos: () => void
  onFechar: () => void
}) {
  return (
    <Modal
      open
      onClose={onFechar}
      title="Arquivar também os itens filhos?"
      footer={
        <>
          <Button variant="ghost" onClick={onFechar} disabled={excluindo}>
            Cancelar
          </Button>
          <Button variant="ghost" onClick={onSomenteEste} disabled={excluindo}>
            Somente este item
          </Button>
          <Button variant="danger" onClick={onComFilhos} disabled={excluindo}>
            {excluindo
              ? 'Arquivando…'
              : filhos === 1
                ? 'Arquivar com o filho'
                : `Arquivar com os ${filhos} filhos`}
          </Button>
        </>
      }
    >
      <p style={{ fontFamily: 'var(--ob-font-body)', fontSize: 13, margin: 0 }}>
        <strong>
          {codigo} — {titulo}
        </strong>{' '}
        tem{' '}
        <strong>
          {filhos} {filhos === 1 ? 'item' : 'itens'}
        </strong>{' '}
        na árvore abaixo dele.
      </p>
      <p
        style={{
          fontFamily: 'var(--ob-font-body)',
          fontSize: 12,
          color: 'var(--ob-text-muted)',
          margin: '10px 0 0',
        }}
      >
        Arquivando só este, os filhos continuam nas listas e nos quadros, debaixo do pai
        marcado como arquivado. O item arquivado sai das listas e dos quadros, mas fica
        guardado, com o histórico. Para apagar de vez, use “Excluir definitivamente”.
      </p>
    </Modal>
  )
}
